import Typography from '@/common/components/base/typography/Typography';
import NoDataIcon from '@/modules/Education/assets/icons/noData.svg?react';
import { Box } from 'styled-system/jsx';

export default function NoEducationList() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="60vh"
    >
      <NoDataIcon />
      <Typography textStyle="b1" color="black-3">
        اطلاعاتی وجود ندارد!
      </Typography>
    </Box>
  );
}
